module.exports = __webpack_public_path__ + "img/VIA.e5644631.svg";